import { render, staticRenderFns } from "./PositionSettingsPage.vue?vue&type=template&id=448add7d&scoped=true&"
import script from "./PositionSettingsPage.vue?vue&type=script&lang=js&"
export * from "./PositionSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448add7d",
  null
  
)

export default component.exports